import { track, AnalyticsEvents } from '../lib/mixpanel'

export const BUY_ME_A_COFFEE_URL =
  import.meta.env.VITE_BUY_ME_A_COFFEE_URL || 'https://www.buymeacoffee.com/jutgojot'

interface BuyMeACoffeeButtonProps {
  source: string
  variant?: 'default' | 'toolbar'
  className?: string
}

export function BuyMeACoffeeButton({ source, variant = 'default', className }: BuyMeACoffeeButtonProps) {
  const compact = variant === 'toolbar'
  return (
    <a
      href={BUY_ME_A_COFFEE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      title="Buy me a coffee"
      onClick={() => track(AnalyticsEvents.SUPPORT_CLICKED, { source })}
    >
      <img
        src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
        alt="Buy Me A Coffee"
        width={217}
        height={60}
        style={{
          height: compact ? 28 : 48,
          width: 'auto',
          display: 'block',
          borderRadius: compact ? 6 : 8,
        }}
      />
    </a>
  )
}
